import AwesomeProjects from "../components/Sections/AwesomeProjects";
import AwesomeProjectsSection from "../components/Sections/AwesomeProjectsSection";
import ProjectsGallery from "../components/Sections/ProjectsGallery";

export default function ProjectsPage() {
  return (
      <>
          <AwesomeProjects />
          <AwesomeProjectsSection />
          <ProjectsGallery />
  
      </>
  )
  
}
